export default {"src":"/_next/static/media/no-data.2f287478.svg","height":632,"width":648,"blurWidth":0,"blurHeight":0};